export const iconFontAwesomeUsersPeopleIdCardClip = (
	<i className="fa-solid fa-id-card-clip"></i>
);
